import { EpiCatalogPanel } from '../../components/epi-catalog-panel';
import { Page } from '../../components/page';

export function EpiCatalog() {
  return (
    <Page>
      <EpiCatalogPanel />
    </Page>
  );
}
